"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const mark_parser_1 = require("@gojipress/mark-parser");
const blankLinePlugin = {
    name: "Blank Line React Syntax Highlighter",
    pluginType: "react-renderer",
    types: [mark_parser_1.GMType.Blank],
    render: node => {
        const elements = [{
                element: () => jsx_runtime_1.jsx("br", {}, void 0)
            }];
        if (typeof node.original === 'string'
        // && node.original.length !== 0 // Render it even if it's blank
        ) {
            elements.unshift({
                element: () => jsx_runtime_1.jsx("span", Object.assign({ className: "gmBlankLine" }, { children: node.original }), void 0),
            });
        }
        return [[{ element: (() => (jsx_runtime_1.jsx(react_1.default.Fragment, { children: elements.map(el => el.element) }, void 0))) }], undefined];
    }
};
exports.default = blankLinePlugin;
